import { COLORS } from "@/components/styles/colors";
import HighlightsPlaylistColumn from "../HighlightsPlaylist/HighlightsPlaylistColumn";
import { Loader } from "lucide-react";
import ProjectOfflineState from "@/components/ProjectOfflineState";
import React from "react";
import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

export default function PublicPageSkeleton({
  offline = false,
  offlineMessage,
}: {
  offline?: boolean;
  offlineMessage?: string;
}) {
  const metaAreaSkeletonHeight = 24;
  const timeLineItemClasses =
    "h-[70px] min-h-[70px] md:h-[100px] md:min-h-[90px] [@media(max-height:425px)]:h-[70px] [@media(max-height:425px)]:min-h-[70px]";
  return (
    <div
      className={cn(
        "w-full flex flex-col md:pb-2 gap-1 h-full",
        "bg-background",
      )}
    >
      <div>
        <div className="flex w-full items-center gap-3 p-2">
          <PageSkeleton
            style={{ height: metaAreaSkeletonHeight, width: 100 }}
            offline={offline}
          />
          <PageSkeleton
            style={{
              height: metaAreaSkeletonHeight,
              width: 48,
              background: COLORS.mellowYellow,
            }}
            offline={offline}
          />
          <PageSkeleton
            className="skeleton"
            style={{ height: metaAreaSkeletonHeight, width: 100 }}
            offline={offline}
          />
          <PageSkeleton
            className="skeletonSmall"
            style={{
              height: metaAreaSkeletonHeight,
              width: 28,
              background: COLORS.mellowYellow,
            }}
            offline={offline}
          />
          <PageSkeleton
            className="skeleton"
            style={{ height: metaAreaSkeletonHeight, width: 89 }}
            offline={offline}
          />
          <PageSkeleton
            className="skeletonSmall"
            style={{
              height: metaAreaSkeletonHeight,
              width: 28,
              background: COLORS.mellowYellow,
            }}
            offline={offline}
          />
          <PageSkeleton
            className="skeleton"
            style={{ height: metaAreaSkeletonHeight, width: 110 }}
            offline={offline}
          />
          <PageSkeleton
            offline={offline}
            className="skeletonSmall"
            style={{
              height: metaAreaSkeletonHeight,
              width: 38,
              background: COLORS.mellowYellow,
            }}
          />
        </div>
      </div>

      <div
        className={cn(
          "w-full p-2 flex items-center gap-3 px-2",
          timeLineItemClasses,
        )}
      >
        <PageSkeleton offline={offline} className="h-full aspect-video" />
        <PageSkeleton offline={offline} className="h-full aspect-video" />
        <PageSkeleton offline={offline} className="h-full aspect-video" />
        <PageSkeleton offline={offline} className="h-full aspect-video" />
        <PageSkeleton offline={offline} className="h-full aspect-video" />
        <PageSkeleton offline={offline} className="h-full aspect-video" />
        <PageSkeleton offline={offline} className="h-full aspect-video" />
        <PageSkeleton offline={offline} className="h-full aspect-video" />
      </div>
      <div className="flex-1 flex">
        <div
          className={cn(
            "w-full grid place-items-center h-full",
            "bg-background",
          )}
        >
          {offline ? (
            <ProjectOfflineState
              className="bg-transparent"
              message={offlineMessage}
            />
          ) : (
            <Loader className="animate-spin" />
          )}
        </div>

        <HighlightsPlaylistColumn>
          <div className="p-3 dark:border-stone-600 border-l-[1px] h-full">
            <PageSkeleton offline={offline} className="h-10 w-full" />
          </div>
        </HighlightsPlaylistColumn>
      </div>
    </div>
  );
}

const PageSkeleton = ({
  offline,
  className,
  style,
}: {
  offline?: boolean;
  className?: string;
  style?: React.CSSProperties;
}) => {
  return (
    <Skeleton
      style={style}
      className={cn(offline && "!bg-muted-foreground !animate-none", className)}
    ></Skeleton>
  );
};
